// extracted by mini-css-extract-plugin
module.exports = {"base":"useModalWorkspaceRemoveMember_base__qM1Os","label":"useModalWorkspaceRemoveMember_label__275v9"};